import BigNumber from "bignumber.js";

export const toWei = (value, decimals) => {
  return new BigNumber(value).multipliedBy(new BigNumber(10).pow(decimals))
}

export const numToWei = (value, decimals = 18) => {
  return new BigNumber(
      toWei(value, decimals).toNumber().toFixed(decimals, 1)
  ).toString()
}
